import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity';
import { FC, useState } from 'react';
import { connect } from 'react-redux';
import {
  DiscountsFormBase,
  ReduxProps,
  OwnProps,
} from '../DiscountsCodeFormBase/DiscountsCodeFormBase';
import { useApplyVoucherCode } from './useApplyVoucherCode';
import { bindActionCreators } from 'redux';
import { fetchBasketDetails } from '@store/basket/actions';
import { useRemoveVoucherCode } from './useRemoveVoucherCode';
import { TranslationKey, useTranslations } from '@lang';

const mapStateToProps = (state) => ({
  basketDetails: basketSelectors.getBasketDetails(state),
  isFetchingBasket: basketSelectors.getIsBasketDetailsFetching(state),
  property: entitySelectors.getProperty(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchBasketDetails,
    },
    dispatch
  );

export const VoucherCodeFormBase: FC<
  OwnProps &
    ReduxProps & {
      fetchBasketDetails: (
        propertyId: number,
        basketId: number | string,
        language: string
      ) => Promise<void>;
      index?: number;
    }
> = ({ property, basketDetails, fetchBasketDetails, isFetchingBasketDetails, ...props }) => {
  const [error, setError] = useState<TranslationKey | null>(null);
  const { t } = useTranslations();
  const refetchBasket = async () => {
    await fetchBasketDetails(property.id, basketDetails.id, property.defaultLanguage);
  };

  const { isLoading: isLoadingApplyVoucher, mutate: applyVoucherMutate } = useApplyVoucherCode(
    property.id,
    basketDetails.id,
    refetchBasket,
    setError
  );
  const { isLoading: isLoadingRemoveVoucher, mutate: removeVoucherMutate } = useRemoveVoucherCode(
    property.id,
    basketDetails.id,
    refetchBasket,
    setError
  );

  const isLoading = isLoadingApplyVoucher || isLoadingRemoveVoucher || isFetchingBasketDetails;
  const errorMessage = error === 'basket.errorApplyingCodeInvalid' ? t(error) : undefined;

  const applyVoucher = async (code: string) => {
    setError(null);
    await applyVoucherMutate(code);
  };
  const removeVoucher = async (code: string) => {
    setError(null);
    await removeVoucherMutate(code);
  };

  return (
    <DiscountsFormBase
      discountType="voucher"
      isLoading={isLoading}
      applyDiscount={applyVoucher}
      removeDiscount={removeVoucher}
      basketDetails={basketDetails}
      property={property}
      error={errorMessage}
      {...props}
    />
  );
};

/**
 * Displays as an input to enter a voucher code, or
 * as a block displaying the voucher code.
 *
 * This block can be shown with or without a cross for removing
 * the voucher code.
 *
 */
export const VoucherCodeForm: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(VoucherCodeFormBase as any);
